export const hijackScrollbar = el => {
  const original = el.style.overflow;
  el.style.overflow = 'hidden';
  return {
    dismiss: () => {
      el.style.overflow = original;
    },
  };
};
